var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_48434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9613 0.36377C14.1247 0.388457 16.0792 0.920165 17.8247 1.95889C19.5493 2.97688 20.984 4.42031 21.9914 6.15114C23.0238 7.90712 23.5523 9.87341 23.5769 12.05C23.5156 15.0281 22.5763 17.5718 20.759 19.6808C18.9416 21.7899 16.6141 23.0948 14.2046 23.595V15.2452H16.4825L16.9977 11.964H13.5483V9.81485C13.5292 9.36932 13.6701 8.93164 13.9455 8.58095C14.2214 8.2293 14.7072 8.04448 15.4029 8.02648H17.4858V5.15218C17.4559 5.14256 17.1723 5.10454 16.635 5.0381C16.0257 4.96681 15.4129 4.92873 14.7994 4.92403C13.4109 4.93043 12.3127 5.32211 11.505 6.09906C10.6972 6.87579 10.2846 7.99956 10.2671 9.47035V11.964H7.64209V15.2452H10.2671V23.595C7.30858 23.0948 4.98099 21.7899 3.16365 19.6808C1.34631 17.5718 0.407025 15.0281 0.345703 12.05C0.370237 9.87331 0.898731 7.90702 1.93118 6.15114C2.93866 4.42031 4.37332 2.97689 6.09798 1.95889C7.8434 0.920365 9.79784 0.388657 11.9613 0.36377Z",
    fill: "#1778F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_48434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.591e6fe9458f6e63fb9f4351147a94fc.svg";
export { ForwardRef as ReactComponent };